var data = {
  "body": "<g fill=\"currentColor\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1 3.5l.5-.5h13l.5.5v9l-.5.5h-13l-.5-.5v-9zm1 1.035V12h12V4.536L8.31 8.9H7.7L2 4.535zM13.03 4H2.97L8 7.869L13.03 4z\"/></g>",
  "width": 16,
  "height": 16
};
exports.__esModule = true;
exports.default = data;